import { createContext } from 'react';

/**
 * @internal
 */
var LayoutGroupContext = createContext({});

export { LayoutGroupContext };
